function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import formList from './formList';
import { crudModuleSaveApi, crudViewSaveApi, crudSeniorListApi, crudModuleListApi, crudSeniorSaveApi } from '@/api/develop';
import oaDialog from '@/components/form-common/dialog-form';
import Commnt from '@/components/develop/commonData';
import exportExcel from '@/components/common/exportExcel';
import viewManagement from '@/components/develop/viewManagement';
import checkboxDialog from '@/components/develop/checkboxDialog';
import conditionDialog from '@/components/develop/conditionDialog';
export default {
  name: '',
  components: {
    formList: formList,
    oaDialog: oaDialog,
    checkboxDialog: checkboxDialog,
    conditionDialog: conditionDialog,
    viewManagement: viewManagement,
    exportExcel: exportExcel
  },
  props: {
    total: {
      type: Number,
      default: 0
    },
    id: {
      type: Number,
      default: 0
    },
    info: {
      type: Object,
      default: function _default() {}
    },
    type: {
      type: String,
      default: ''
    },
    keyName: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isShow: false,
      viewShow: false,
      searchTypeOptions: Commnt.searchTypeOptions,
      title: '',
      max: 0,
      min: 0,
      sortIndex: '',
      viewText: '我查看的',
      viewIndex: '0',
      saveName: '',
      exportData: {
        data: [],
        cols: [{
          wpx: 70
        }, {
          wpx: 70
        }, {
          wpx: 120
        }, {
          wpx: 140
        }, {
          wpx: 120
        }]
      },
      fromData: {
        width: '500px',
        title: '新建视图',
        btnText: '确定',
        labelWidth: '100px',
        type: ''
      },
      formDataInit: {
        senior_title: '',
        senior_type: '0'
      },
      formConfig: [{
        type: 'input',
        label: '视图名称：',
        placeholder: '请输入视图名称(10个字以内)',
        key: 'senior_title'
      }, {
        type: 'radio',
        label: '视图类型：',
        placeholder: '请选择视图类型',
        key: 'senior_type',
        options: [{
          value: '个人',
          label: '0'
        }, {
          value: '公共',
          label: '1'
        }]
      }],
      formRules: {
        senior_title: [{
          required: true,
          message: '请输入视图名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 10,
          message: '最多输入10个字',
          trigger: 'blur'
        }],
        senior_type: [{
          required: true,
          message: '请选择视图类型',
          trigger: 'change'
        }]
      },
      sortList: [{
        name: '升序',
        value: '1'
      }, {
        name: '降序',
        value: '0'
      }, {
        name: '默认排序',
        value: ''
      }],
      dropdownList: [{
        label: '筛选条件设置',
        value: 2
      }, {
        label: '表头显示设置',
        value: 3
      }, {
        label: '批量删除',
        value: 1
      }, {
        label: '导出',
        value: 4
      }],
      where: {
        show_search_type: '0',
        view_search: [],
        order_by: {},
        scope_frame: 'all',
        view_search_boolean: ''
      },
      viewList: [],
      viewItem: {},
      activeIds: [],
      activeIndex: 0,
      searchType: 0,
      filterData: [],
      additional_search: [],
      additional_search_boolean: ''
    };
  },
  watch: {
    info: {
      handler: function handler(val) {
        if (val && val.orderByField) {
          this.saveName = '导出' + val.crudInfo.table_name + '.xlsx';
          this.filterData = val.orderByField.map(function (data) {
            return {
              label: data.field_name,
              value: data.field_name_en,
              id: data.id || null,
              sortBy: 0,
              isChecked: false
            };
          });
        }
      },
      deep: true
    },
    // 给条件设置组装数据
    additional_search: function additional_search(val) {
      var _this = this;
      this.where.view_search = [];
      val.map(function (item) {
        var obj = {
          operator: item.value,
          form_field_uniqid: item.field,
          value: item.option,
          obj: item
        };
        if (!item.option && item.category === 2) {
          obj.value = [];
          item.options.userList.map(function (i) {
            obj.value.push(i.value);
          });
        } else if (!item.option && item.category === 1) {
          obj.value = [];
          item.options.depList.map(function (i) {
            obj.value.push(i.id);
          });
        }
        if (obj.operator === 'between') {
          var data = {
            min: item.min,
            max: item.max
          };
          obj.value = data;
        }
        _this.where.view_search.push(obj);
      });
      this.$emit('confirmData', this.where);
    },
    additional_search_boolean: function additional_search_boolean(val) {
      this.where.view_search_boolean = val;
    }
  },
  mounted: function mounted() {
    this.getViewList();
    this.confirmData();
  },
  methods: {
    addViewFn: function addViewFn() {
      this.$refs.oaDialog.openBox();
      this.viewShow = false;
    },
    // 新建视图
    submit: function submit(data) {
      var _this2 = this;
      data.sort = 0;
      data.search_boolean = this.where.view_search_boolean;
      data.senior_search = this.additional_search;
      crudSeniorSaveApi(this.keyName, data).then(function (res) {
        if (res.status == 200) {
          _this2.getViewList();
          _this2.$refs.oaDialog.handleClose();
        }
      });
    },
    // 获取实体管理数据
    getViewList: function getViewList(title) {
      var _this3 = this;
      var data = {
        title: title || ''
      };
      crudSeniorListApi(this.keyName, data).then(function (res) {
        _this3.viewList = res.data;
        _this3.viewList.forEach(function (item, index) {
          item.index = index + 'view';
        });
      });
    },
    updateView: function updateView() {
      var _this4 = this;
      var obj = {
        sort: 0,
        search_boolean: this.where.view_search_boolean,
        senior_search: this.additional_search,
        senior_title: this.viewItem.senior_title,
        senior_type: this.viewItem.senior_type,
        id: this.viewItem.id
      };
      crudSeniorSaveApi(this.keyName, obj).then(function (res) {
        _this4.getViewList();
        _this4.viewShow = false;
      });
    },
    openViewBox: function openViewBox() {
      this.$refs.viewManagement.openBox();
    },
    viewClick: function viewClick(item) {
      this.viewIndex = item.index;
      this.viewItem = item;
      this.viewText = item.senior_title;
      this.where.view_search_boolean = item.search_boolean;
      this.additional_search = item.senior_search;
      this.$refs.popoverType.doClose();
    },
    typeClick: function typeClick(item) {
      this.viewIndex = item.value;
      this.viewText = item.label;
      this.where.show_search_type = item.value;
      this.confirmData();
      this.additional_search = [];
      // let data = {
      //   list: [],
      //   type: '',
      //   additional_search_boolean: '0'
      // }
      // this.$store.commit('uadatefieldOptions', data)
      this.$refs.popoverType.doClose();
    },
    onShow: function onShow() {
      var list = [];
      if (this.where.view_search && this.where.view_search.length > 0) {
        this.where.view_search.map(function (item) {
          list.push(item.obj);
        });
      } else {
        list = [];
      }
      var data = {
        list: list,
        type: '',
        additional_search_boolean: this.where.view_search_boolean
      };
      if (this.where.view_search_boolean == '') {
        this.where.view_search_boolean = '0';
      }
      this.$store.commit('uadatefieldOptions', data);
      this.$store.commit('updateConditionDialog', true);
    },
    saveCondition: function saveCondition() {
      this.additional_search = this.$store.state.business.fieldOptions.list;
      this.where.view_search_boolean = this.$store.state.business.fieldOptions.additional_search_boolean;
    },
    // 新增
    addData: function addData() {
      this.$emit('addData');
    },
    dropdownSearch: function dropdownSearch(val) {
      var _this5 = this;
      if (val.value === 2) {
        this.max = 2;
        this.min = 0;
        this.title = '搜索显示设置';
        this.searchType = 2;
        var searchCrudInfo = _objectSpread(_objectSpread({}, this.info.crudInfo), {}, {
          customField: (this.info.crudInfo.customField || []).filter(function (item) {
            return !['file', 'image'].includes(item.form_value);
          })
        });
        this.$refs.checkboxDialog.openBox(searchCrudInfo, this.info.seniorSearch);
      } else if (val.value === 3) {
        this.max = 0;
        this.min = 5;
        this.title = '表头显示设置';
        this.searchType = 3;
        this.$refs.checkboxDialog.openBox(this.info.crudInfo, this.info.showField);
      } else if (val.value === 1) {
        this.$emit('handleDelete');
      } else if (val.value == 4) {
        // 导出
        if (this.total > 1000) {
          return this.$message.error('超出限制，最大支持导出1000条数据');
        }
        this.where.page = 0;
        this.where.limit = 1000;
        var list = [];
        var aoaData = [];
        var arr = [];
        crudModuleListApi(this.keyName, this.where).then(function (res) {
          list = res.data.list;
          list.forEach(function (item) {
            delete item['id'];
          });
          _this5.info.showField.map(function (item) {
            arr.push(item.field_name);
          });
          aoaData[0] = arr;
          if (list.length > 0) {
            list.forEach(function (el) {
              var elData = _this5.getVal(Object.values(el));
              aoaData.push(elData);
            });
          }
          _this5.exportData.data = aoaData;
          _this5.$refs.exportExcel.exportExcel();
        });
      }
    },
    getVal: function getVal(list) {
      var str = [];
      list.map(function (val) {
        if (val == '') {
          val = '--';
        } else if (Array.isArray(val)) {
          val = val.toString();
        } else {
          val = val || '--';
        }
        str.push(val);
      });
      return str;
    },
    handleEmit: function handleEmit(data) {
      this.where = _objectSpread(_objectSpread({}, this.where), data);
      this.$emit('confirmData', this.where, this.keyName);
    },
    confirmData: function confirmData() {
      if (this.where.show_search_type != 0) {
        this.where.scope_frame = 'all';
      }
      this.$emit('confirmData', this.where);
    },
    // 点击排序
    handleClick: function handleClick(data) {
      this.activeIndex = data.value;
      this.where.order_by = {};
      if (this.sortIndex == '') {
        this.where.order_by = {};
      } else {
        this.where.order_by[data.value] = this.sortIndex;
      }
      this.$emit('confirmData', this.where);
    },
    sortFn: function sortFn(item) {
      this.sortIndex = item.value;
      this.where.order_by = {};
      if (item.value == '') {
        this.where.order_by = {};
      } else {
        this.where.order_by[this.activeIndex] = item.value;
      }
      this.$emit('confirmData', this.where);
    },
    getData: function getData(data) {
      var _this6 = this;
      var obj = {};
      if (this.searchType == 2) {
        obj.senior_search = data.ids;
      } else if (this.searchType == 3) {
        // 表头保存时强制保留 file 列（列表默认显示字段）
        var ids = Array.isArray(data.ids) ? data.ids.slice() : [];
        var listFields = this.info.crudInfo && this.info.crudInfo.customListField || [];
        listFields.forEach(function (item) {
          if (item.form_value === 'file' && !ids.includes(item.field_name_en)) {
            ids.push(item.field_name_en);
          }
        });
        obj.show_field = ids;
      }
      if (this.type == 'view') {
        crudViewSaveApi(this.id, obj).then(function (res) {
          _this6.$emit('getInfo');
          _this6.$emit('getList');
        });
      } else {
        crudModuleSaveApi(this.keyName, obj).then(function (res) {
          _this6.$emit('getInfo');
          _this6.$emit('getList');
        });
      }
    },
    resetSearch: function resetSearch() {
      this.where = {
        show_search_type: '0',
        view_search: [],
        order_by: {},
        scope_frame: 'all',
        view_search_boolean: '',
        keyword_default: ''
      };
      this.viewText = '我查看的';
      this.additional_search = [];
      var data = {
        list: [],
        type: '',
        additional_search_boolean: '0'
      };
      this.$store.commit('uadatefieldOptions', data);
      if (this.info.seniorSearch.length == 0) {
        this.$emit('confirmData', this.where);
      }
    }
  }
};